import React, { useState, useEffect, useRef } from 'react';
import Header from '../components/Header';
import { NavLink } from 'react-router-dom';
import { P5Canvas } from "@p5-wrapper/react";
import { Canvas, useLoader } from '@react-three/fiber';
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js'

const Home = () => {
    const [loading, setLoading] = useState(false);
    const [showArrow, setShowArrow] = useState(true);
    const [intersecting, setIntersecting] = useState(false);
    const [intersectingSecond, setIntersectingSecond] = useState(false);
    const [intersectingThird, setIntersectingThird] = useState(false);
    const [intersectingFourth, setIntersectingFourth] = useState(false);
    const [intersectingFifth, setIntersectingFifth] = useState(false);
    const firstSectionRef = useRef(null);
    const secondSectionRef = useRef(null);
    const thirdSectionRef = useRef(null);
    const fourthSectionRef = useRef(null);
    const fifthSectionRef = useRef(null);
    const gltf = useLoader(GLTFLoader, './dentures_again.glb')

    useEffect(() => {
        const observerOptions = {
            root: null,
            rootMargin: '0px',
            threshold: .1
        };

        const observer = new IntersectionObserver(([entry]) => {
            if (!entry.isIntersecting) {
                if (entry.target.id == 'first') {
                    setShowArrow(false)
                    setIntersecting(false)
                }
                if (entry.target.id == 'second') {
                    setIntersectingSecond(false);
                }
                if (entry.target.id == 'third') {
                    setIntersectingThird(false);
                }
                if (entry.target.id == 'fourth') {
                    setIntersectingFourth(false);
                }
                if (entry.target.id == 'fifth') {
                    setIntersectingFifth(false);
                }
            } else {
                if (entry.target.id == 'first') {
                    setShowArrow(true)
                    setIntersecting(true)
                }
                if (entry.target.id == 'second') {
                    setIntersectingSecond(true);
                }
                if (entry.target.id == 'third') {
                    setIntersectingThird(true);
                }
                if (entry.target.id == 'fourth') {
                    setIntersectingFourth(true);
                }
                if (entry.target.id == 'fifth') {
                    setIntersectingFifth(true);
                }
            }
        }, observerOptions);

        if (firstSectionRef.current !== null) {
            observer.observe(firstSectionRef.current);
        }

        if (secondSectionRef.current !== null) {
            observer.observe(secondSectionRef.current);
        }

        if (thirdSectionRef.current !== null) {
            observer.observe(thirdSectionRef.current);
        }

        if (fourthSectionRef.current !== null) {
            observer.observe(fourthSectionRef.current);
        }

        if (fifthSectionRef.current !== null) {
            observer.observe(fifthSectionRef.current);
        }
    }, []);

    return (
        <div className={`home ${!loading && "loaded"}`}>
            <div id="first" ref={firstSectionRef}>
                <Header />
                <Canvas className='canvas-container'>
                    <pointLight position={[10, 10, 10]} />
                    <mesh>
                        <primitive object={gltf.scene} scale={0.4} rotation={[0, Math.PI, 0]}/>
                    </mesh>
                    {/* <P5Canvas sketch={sketch.current} 
                    intersecting={intersecting} 
                    intersectingSecond={intersectingSecond} 
                    intersectingThird={intersectingThird} 
                    intersectingFourth={intersectingFourth} 
                    intersectingFifth={intersectingFifth}/> */}
                </Canvas>
                <div className={`down-container ${showArrow ? '' : 'hideArrow'}`}>
                    <svg width="53" height="29" viewBox="0 0 53 29" fill="none" className="link" id="arrow" alt="" style={{ opacity: 1 }}>
                        <path d="M0.707092 1.29297L26.7839 27.3698M25.2926 27.3701L51.3694 1.29331" stroke="black" strokeWidth="2"></path>
                    </svg>
                </div>
            </div>
            <div id="second" ref={secondSectionRef}>
                <h1>"ai" does not exist</h1>
                <NavLink to="/essays/ai-linguistics" className="essay-link">linguistics of "ai"</NavLink>
                <NavLink to="/essays/ai-history" className="essay-link">history of "ai"</NavLink>
                <NavLink to="/essays/wip" className="essay-link">psychiatry & "ai"</NavLink>
                <NavLink to="/essays/wip" className="essay-link">fascism & "ai"</NavLink>
                <NavLink to="/essays/wip" className="essay-link">after "ai"</NavLink>
            </div>
            <div id="third" ref={thirdSectionRef}>
                <h1>"sanity" is obedience</h1>
                <NavLink to="/essays/wip" className="essay-link not-done">chatbots & therapy</NavLink>
                <NavLink to="/essays/wip" className="essay-link not-done">american suicidality</NavLink>
                <NavLink to="/essays/wip" className="essay-link not-done">loneliness endemic</NavLink>
                <NavLink to="/essays/wip" className="essay-link not-done">incels, femcels, & romance</NavLink>
            </div>
            <div id="fourth" ref={fourthSectionRef}>
                <h1>health is interdependence</h1>
                <NavLink to="/essays/wip" className="essay-link not-done">decolonizing social prescribing</NavLink>
                <NavLink to="/essays/wip" className="essay-link not-done">alone</NavLink>
                <NavLink to="/essays/wip" className="essay-link not-done">death & well-being</NavLink>
            </div>
            <div id="fifth" ref={fifthSectionRef}>
                <h1>short essays</h1>
                <NavLink to="/essays/anti-intellectual" className="essay-link">anti-intellectualism & medicine</NavLink>
                <NavLink to="/essays/therapists" className="essay-link">therapy & the medical model of disability</NavLink>
                <NavLink to="/essays/chatbots-draft" className="essay-link">chatbots & therapy (draft)</NavLink>
            </div>
        </div>
    );
}

export default Home;